import {useState, useEffect} from 'react';
import { useParams } from 'react-router-dom';
import Skills from './Skills';
import Questions from './Questions';
import Summary from './Summary';
import Answers from './Answers';

function Create({user}) {
	const { randomId } = useParams();
	const [step, setStep] = useState('skills');
	const [jobTitle, setJobTitle] = useState('');
	const [jobDescription, setJobDescription] = useState('');
	const [storedData, setStoredData] = useState(null);

	useEffect(() => {
		let data = localStorage.getItem(randomId);
		if (!data) {
			return;
		}
		data = JSON.parse(data);

		console.log(data);
		
		setStoredData(data);
		setJobTitle(data.jobTitle);
		setJobDescription(data.jobDescription);
		if(data.interview_id){
			setStep('summary')
			return
		} else if ((data?.selectedHardQuestions?.length > 0) || (data?.selectedSoftQuestions?.length > 0)){
			setStep('summary')
			return
		}else if (data?.selectedSoftSkills?.length > 0) {
			setStep('questions')
			return
		}else{
			setStep('skills');
		}
	}, []);
	return (
		<>
			{step === 'skills' &&
				<Skills jobTitle={jobTitle} jobDescription={jobDescription} storedData={storedData} randomId={randomId} setStoredData={setStoredData} setStep={setStep} />
			}
			{step === 'questions' &&
				<Questions jobTitle={jobTitle} jobDescription={jobDescription} storedData={storedData} randomId={randomId} setStoredData={setStoredData} setStep={setStep} />
			}
			{step === 'summary' &&
				<Summary jobTitle={jobTitle} jobDescription={jobDescription} storedData={storedData} randomId={randomId} setStoredData={setStoredData} setStep={setStep} token={user.token} />
			}
		</>
	)
}

export default Create